import React from "react";
import "./Evolution.scss";
import arrowUp from "../../../img/Arrow/arrow-up.png";
import arrowDown from "../../../img/Arrow/arrow-down.png";
import arrowNeutral from "../../../img/Arrow/arrow-neutral.png";

export default function Evolution({
  arrow,
  price,
  origin,
  currency,
  decimals,
}) {
  let arrowSvg;

  if (arrow === 0) {
    arrowSvg = arrowNeutral;
  } else if (arrow > 0) {
    arrowSvg = arrowUp;
  } else {
    arrowSvg = arrowDown;
  }
  return (
    <div className="Evolution">
      <div className="Evolution__value">
        <div className="Evolution__arrow">
          <img src={arrowSvg} alt="" />
        </div>
        <div className="Evolution__price">
          {price ? price.toFixed(decimals) : "..."}
        </div>
      </div>
      <div className="Evolution__supplements">
        <div className="Evolution__origin">{origin}</div>
        <div className="Evolution__currency">{currency}</div>
      </div>
    </div>
  );
}

Evolution.defaultProps = {
  decimals: 2,
};
